import { render } from "./MemberEdit.vue?vue&type=template&id=28e5aed8&scoped=true"
import script from "./MemberEdit.vue?vue&type=script&lang=js"
export * from "./MemberEdit.vue?vue&type=script&lang=js"

import "./MemberEdit.vue?vue&type=style&index=0&id=28e5aed8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-28e5aed8"

export default script